import { Component, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';


import { ApiService, DialogsService } from '../../custom-material/Services/';
import { ChapterModel, IndigroupModel, IndicateurModel, DiagnosticModel, AnswerModel, BuildingModel, UserModel, Colors } from '../../main/Models/';
import { globalData } from 'src/app/main/Models/global.model';
import { toollist } from './questionnary.tools';


@Component({
  selector: 'audit-questionnary',
  templateUrl: './t_questionnary.component.html',
  styleUrls: ['./questionnary.component.less']
})
export class QuestionnaryComponent implements OnInit {

  ////building:BuildingModel = new BuildingModel({});
  diagnostic: DiagnosticModel = new DiagnosticModel({});
  chapters:Array<ChapterModel> = [];

  answersToSave:Array<any> = [];  //get AnswerModel.export() result instead of complete AnswerModel

  ////currentChapter:number;
  ////indiGroups = [];
  indicators = [];
  openedIndicator: IndicateurModel;

  nbIndicators = 0;
  countIndiGroupsToLoad = 0;

  progression = '';
  linearNote = '';
  pondNote = '';
  totalUncompleted:number = 0;

  spinnerRunning = false;
  flashMessage = "";
  showIDs = false;
  showSummary = false;
  showManual = false;

  toggleManual() { this.showManual = !this.showManual; }
  toggleSummary() { this.showSummary = !this.showSummary; }


  saveInterval = null;


  get isSuperadmin() {
    return this.apiService.connectedUser.state==3;
  }
  get isAdmin() {
    return this.gd.connectedUser.state>=2;
  }

  get isAuditor() {
    return this.gd.connectedUser.isAuditor;
  }


  /*get allSlices()
   {
    return ['Alarmant', 'Préocupant', 'Important', 'Positif'].map((e,i)=>{
      return {
        name: e,
        color: Colors.colors[i]
      }
    })
  }*/


  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private gd: globalData,
    private dialog: MatDialog,
    private dialogService: DialogsService,
    private snackBar: MatSnackBar) {
      //this.gd.toollist = toollist;
      this.gd.toolService = this;
      this.gd.showChooser = false;
    }

  ngOnInit() {
    //ID of diagnostic in the URL (/diagnostic/<id>)
  	let diagnostic_id = +this.route.snapshot.params['diagnostic'];
  	this.loadCompleteDiagnostic(diagnostic_id);
  }

  /**
  * Quit this page = stop autosave
  */
  ngOnDestroy()
  {
    this.quickSave();
    if(this.saveInterval!=null) clearInterval(this.saveInterval);
  }


  /*
  * load diagnostic from the API
  * (with all data : building, questionnary, chapters, groups, indicators, answers)
  * @param number
  */
  loadCompleteDiagnostic(diagnostic_id)
  {
    //start showing wait signals
    this.spinnerRunning = true;
    //setTimeout is a hack, without it snackBar bugs
    setTimeout(()=>{ this.snackBar.open('Chargement en cours') }, 0);


  	this.apiService.getOneFromServer('diagnostic', diagnostic_id)
	    .then(s => s.subscribe((response:any) => {
	    	this.diagnostic.exchange(response.diagnostic);
	    	//this.diagnostic.building.exchange(response.building);
        this.diagnostic.building = this.gd.findBuildingById(response.building);
        this.gd.headerBuilding = this.diagnostic.building;
	    	this.diagnostic.questionnary.exchange(response.questionnary);
        this.gd.headerTitle = this.diagnostic.questionnary.name;
        this.gd.headerIcon = 'youtube_searched_for';

	    	response.chapters.forEach((ch)=>{
	    		//this.chapters[ch.ordre] = new ChapterModel(ch);
          this.chapters.push( new ChapterModel(ch) );
	    	});

        this.chapters.sort((a,b)=>{ return a.ordre>b.ordre?1:-1});

        this.calcInit();
        this.calcRatio();


        //stop showing wait signals
        this.spinnerRunning = false;
        setTimeout(()=>{ this.snackBar.dismiss(); }, 0);

        //this.currentChapter = 0;  //-> allow view of indicators
	    }));
  }

  /*
  * First calculation after load :
  * slice for each answers + nb of indicators
  */
  calcInit()
  {
    this.nbIndicators = 0;
    this.chapters.forEach((chapter:ChapterModel)=>{
      chapter.indiGroups.forEach((indiGroup:IndigroupModel)=>{

        this.nbIndicators += indiGroup.indicators.length;

        indiGroup.indicators.forEach((indicator:IndicateurModel)=>{
          if(!this.isAuditor) indicator.answer.evolution = 5;

          let score = indicator.answer.finalScore;
          let slice = this.diagnostic.questionnary.getSlice(score);
          indicator.answer.slice = slice;

          this.indicators.push(indicator);
        })
      })
    });

    this.setIndicator(0);
    //this.showSummary = true;
  }

  setIndicator(index:number) { this.openedIndicator = this.indicators[index]; }
  nextIndicator()
  {
    const index = this.indicators.indexOf(this.openedIndicator);
    if(index == this.indicators.length-1) return;
    this.setIndicator(index+1);
  }
  previousIndicator()
  {
    const index = this.indicators.indexOf(this.openedIndicator);
    if(index == 0) return;
    this.setIndicator(index-1);
  }

  /**
  * called when something change in an answer
  */
  setChanged(indicator:IndicateurModel, calcRatioAfterChanged:boolean = true)
  {
    if(this.saveInterval==null) {
      this.saveInterval = setInterval(() => this.quickSave(), 300000);  //300000 ms = 300s=5min ; 10000 = 10s
    }
    this.answersToSave[indicator.id] = indicator.answer.export();

    //recalc slice
    indicator.answer.slice = this.diagnostic.questionnary.getSlice(indicator.answer.finalScore);

    if(calcRatioAfterChanged) this.calcRatio();
  }

  /**
  * Calculation of stats (filling ratio and note)
  * called after each changes
  */
  calcRatio()
  {
    let nbAnswers:number = 0;          //total of answers completed
    let nbNotableAnswers:number = 0;   //total of answers completed except out of scoring (multichoicegravity=-10)
    let scoreTotal:number = 0;         //total score
    let pondNbAnswers:number = 0;      //total of ponderations
    let pondScoreTotal:number = 0;     //total of poderate score

    this.chapters.forEach((chapter:ChapterModel)=>{
    	chapter.indiGroups.forEach((indiGroup:IndigroupModel)=>{
    		let answersInfos = indiGroup.answersInfos;

    		nbAnswers += answersInfos.completed;
        nbNotableAnswers += answersInfos.completedAndNotable;
    		scoreTotal += answersInfos.score;
    		pondNbAnswers += answersInfos.pondNbAnswers;
    		pondScoreTotal += answersInfos.pondScore;
    	});
    });

    this.diagnostic.ratio = Math.round((nbAnswers / this.nbIndicators) * 100);
    this.progression = nbAnswers+' / '+this.nbIndicators;
    this.totalUncompleted = this.nbIndicators - nbAnswers;

    let linearScore = scoreTotal / nbNotableAnswers;  // ((20 * scoreTotal) / (nbNotableAnswers * 25));
    this.linearNote = this.calcNote(linearScore);

    let pondScore =pondScoreTotal / pondNbAnswers;  //20 * pondScoreTotal) / (pondNbAnswers * 25));
    this.pondNote = this.calcNote(pondScore);

    let noteTools = [
      {
        "Type": "Text",
        "Label": "Note",
        "Value": this.linearNote,
        "Color": "disabled",
        "Icon": "sports_score",
      },
      {
        "Type": "Text",
        "Label": "Weighted",
        "Value": this.pondNote,
        "Color": "disabled",
        "Icon": "sports_score",
      }
    ]
    this.gd.toollist = [ ...noteTools, ...toollist];
  }

  calcNote(score)
  {
    //=IF(K15<6; (K15*1); IF(K15<=12;K15*1,1;IF(K15<=16;K15;IF(K15<25;K15*0,9;K15*0,8))))
    let coef = 1;
    if(score<6) coef = 1;
    else if(score<=12) coef = 1.1;
    else if(score<16) coef = 1;
    else if(score<=17) coef = 0.9;
    else if(score<=18) coef = 0.87;
    else if(score<=19) coef = 0.84;
    else coef = 0.8;

    let note =  20 - (score * coef);
    return note.toFixed(2);
  }

  /**
  * Called on "return" button
  * -> save diagnostic then back to building page
  */
  saveAndGoBack()
  {
    this.saveDiagnostic().then(()=>{
      this.dialogService.confirm('questionnary-quit-confirm-message')
          .subscribe(resp => {
            if(resp) this.router.navigate(['/buildings/'+this.diagnostic.building.id]);
          });
    });
  }
  saveAndGotoReport()
  {
    this.saveDiagnostic().then(()=>{
      this.dialogService.confirm("questionnary-gotoreport-confirm-message", "questionnary-gotoreport-confirm-title")
          .subscribe(resp => {
            if(resp) this.router.navigate(['report/'+this.diagnostic.id]);
          });
    });
  }
  /**
  * back to building page
  * /
  goBack()
  {
      this.router.navigate(['/buildings/'+this.diagnostic.building.id]);
  }
  /**
   * go to report
   * /
  gotoReport()
  {
    this.router.navigate(['report/'+this.diagnostic.id]);
  }*/

  /**
  * Just save and do nothing
  * saveDiagnostic returns a Promise, and does not work without a 'then'
  */
  quickSave()
  {
    this.saveDiagnostic().then(()=>{});
  }

  /**
  * update diagnostic data + save modified answers
  */
  saveDiagnostic()
  {
    return new Promise((resolve, reject)=>{
      //start showing wait signals
      this.spinnerRunning = true;
      setTimeout(()=>{ this.snackBar.open('Sauvegarde en cours') }, 0);


  	  this.diagnostic.rapport = '';
        this.apiService.UpdateToServer('diagnostic', {
            id: this.diagnostic.id,
            ratio: this.diagnostic.ratio,
            rapport: this.diagnostic.rapport,
            finished: 0,
            answer_replace: this.answersToSave.filter((v)=>v!=null)
         })
         .then(s => s.subscribe(
            response => {
              //stop showing wait signals and re-init autosave processus
              this.spinnerRunning = false;
              setTimeout(()=>{ this.snackBar.dismiss(); }, 20);
              clearInterval(this.saveInterval);
              this.saveInterval = null;
              this.answersToSave = [];

              resolve(1);
            }
         ) );
    });
   }

  /**
  * ramdomly fill every answers
  * used to test a questionnary
  */
  autofill()
  {
  	this.chapters.forEach((chapter:ChapterModel)=>{
  		chapter.indiGroups.forEach((indiGroup:IndigroupModel)=>{
  			indiGroup.indicators.forEach((indicator:IndicateurModel)=>{

  			  indicator.answer.evolution = Math.floor(Math.random() * 5) + 1;
          if(indicator.multichoicegravity==-10) {
            indicator.answer.revelent=0;
          } else if(indicator.multichoicegravity!=0) {
		        for (let g=0; g<5; g++) {
		          indicator.answer.gravityArray[g] = (Math.random() > 0.5);
		        }
		      } else {
            indicator.answer.gravityScore = null;

            let rndOrder = [0,1,2,3,4].sort(()=>{return Math.random()-0.5});
            rndOrder.forEach((g)=>{
              if(indicator.answer.gravityScore==null
              && indicator.gravities[g]
              && indicator.gravities[g].label!='') {
                indicator.answer.gravityScore = indicator.gravities[g].weight;
              }
            });
            if(indicator.answer.gravityScore==null) indicator.answer.gravityScore=5;
		      }

		      this.setChanged(indicator, false);
  			});
  		});
  	});

    this.calcRatio();
  }



  /**
  * push pictures container scroll to the right
  * /
  pushToRight(indicator:IndicateurModel)
  {
    let element = document.getElementById('pics-'+indicator.id);
    if(element==null) return;
    setTimeout(()=>{
      let scrollX = indicator.answer.freephoto.length * 200;
      element.scroll(element.clientWidth, 0);
    }, 100);

  }

  /** old : version chapter by chapter
  * navigate throw the questionnary, to a chapter or a group
  * /
  navigateTo(chap, group=null)
  {
    let anchor = '';
    if(group) {
      anchor = 'group'+group;
    } else if(chap=0) {
      anchor = 'mainList';
    } else {
      anchor = 'chap'+chap;
    }
    this.currentChapter = chap;
    this.quickSave();

    setTimeout(()=>{
      try {
        document.querySelector('#' + anchor).scrollIntoView();
        window.scrollBy(0, -200 );
      } catch (e) { }
      this.showSummary = false;
    }, 200);

  }

  /**
  *  go to next of previous chapter
  * /
  nextChapter(sens=1) //sens = 1 ou -1
  {
    if(this.chapters[this.currentChapter+sens]==undefined
    || this.chapters[this.currentChapter+sens].indiGroups == null
    || this.chapters[this.currentChapter+sens].indiGroups.length==0) return;

    this.saveDiagnostic().then(()=>{
      this.currentChapter+=sens;
      setTimeout(()=>{
        //document.querySelector('#content').scrollIntoView();
        window.document.getElementById('content').scrollTo(0, 0);
      }, 50);
    });

  }
  previousChapter() { this.nextChapter(-1); }
*/


  /*********************************************************************************
  * Some client wants the recorded score to be different than the calculated one
  * so I had a "popup" to manage that
  *
  * Here are propertes and methods for this
  ********************************************************************************** /


  showForcing:boolean = false;  //show the the popup ?
  forcingIndicator:IndicateurModel; //witch indicator to force

  /**
  * Open forcing popup for the given indicator's answer
  * /
  openForcing(indicator:IndicateurModel)
  {
    this.forcingIndicator = indicator;
    if(indicator.answer.forcingScore==null) indicator.answer.forcingScore=indicator.answer.score;
    this.showForcing = true;
  }

  /**
  * Cancel the forcing for
  * /
  resetForcing()
  {
    this.forcingIndicator.answer.forcingScore=this.forcingIndicator.answer.score;
  }

  /*
  * Close forcing popup
  * /
  closeForcing()
  {
    let answer = this.forcingIndicator.answer;
    if(answer.forcingScore==answer.score) answer.forcingScore=null;
    this.showForcing = false;
    this.forcingIndicator = null;
  }

  /*
  * delete all forcing scores (only for superadmin)
  * /
  recalcAll()
  {
    this.chapters.forEach((chapter:ChapterModel)=>{
  		chapter.indiGroups.forEach((indiGroup:IndigroupModel)=>{
  			indiGroup.indicators.forEach((indicator:IndicateurModel)=>{
  			  indicator.answer.forcingScore = null;
		      this.setChanged(indicator, false);
  			});
  		});
  	});


    this.calcRatio();
    this.quickSave();
  }
  */

}
